"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FileInput_1 = __importDefault(require("shared/components/Form/FileInput"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var docMethods_1 = require("utils/docMethods");
var storage_1 = require("utils/firebase/storage");
var validators_1 = require("utils/form/validators");
var HoCs_1 = require("utils/HoCs");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var SubmitPopup_1 = __importDefault(require("../SubmitPopup"));
var Mfa_1 = __importDefault(require("./Mfa"));
var MyAccount = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var authState = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var _a = __read((0, hooks_1.useSubmitter)('users', authState === null || authState === void 0 ? void 0 : authState.uid), 1), userSubmitter = _a[0];
    // a temporary solution for the last name until we have lastName field
    var initialValues = (0, pick_1.default)((0, docMethods_1.fillWithNames)(profile), ['firstName', 'lastName']);
    if (!(0, react_redux_firebase_1.isLoaded)(profile)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var onSubmit = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var avatarUpdate, _b, valuesToSave;
        var avatar = _a.avatar, values = __rest(_a, ["avatar"]);
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!avatar) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, storage_1.uploadProfileAvatar)(profile, avatar[0])];
                case 1:
                    _b = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _b = {};
                    _c.label = 3;
                case 3:
                    avatarUpdate = _b;
                    valuesToSave = __assign(__assign(__assign({}, values), avatarUpdate), { displayName: "".concat(values.firstName, " ").concat(values.lastName) });
                    return [4 /*yield*/, userSubmitter(valuesToSave)];
                case 4:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "My account", description: "My Account" }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ width: 1000, mt: 1, mx: "auto", mb: 2, px: 6, pb: 4 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "My account" })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ maxWidth: 300 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ initialValues: initialValues, onSubmit: onSubmit }, { children: function (_a) {
                                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting, pristine = _a.pristine, form = _a.form, errors = _a.errors;
                                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "avatar", component: FileInput_1.default, label: "Photo", defaultImage: profile.avatarUrl, afterSubmit: form.reset, fullWidth: true }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mt: 3 }, { children: "Personal Info" })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mt: 3 }, { children: (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "firstName", disabled: submitting, validate: (0, validators_1.required)(), showLabel: true, fullWidth: true }) })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mt: 3 }, { children: (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "lastName", disabled: submitting, validate: (0, validators_1.required)(), showLabel: true, fullWidth: true }) })), (0, jsx_runtime_1.jsx)(SubmitPopup_1.default, { isOpen: !pristine, onSave: handleSubmit, onCancel: form.reset, formError: Object.keys(errors || {}).length > 0, context: "My Account" })] })));
                                } })) })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pt: 8 }, { children: (0, jsx_runtime_1.jsx)(Mfa_1.default, {}) }))] })) }))] }));
};
exports.default = react_1.default.memo((0, HoCs_1.HasCompanyHoC)(MyAccount));
